import type { RootState } from "~/redux/store";

export const selectUnitMode = (state: RootState) => state.userPreferences.unitMode;
export const selectIsUseNewDesign = (state: RootState) => state.userPreferences.useNewDesign;
export const selectSearchDisplayMode = (state: RootState) => {
  const { useNewDesign, searchDisplayMode } = state.userPreferences;
  return useNewDesign ? searchDisplayMode.new : searchDisplayMode.old;
};
